<template>
  <div class="text-center">
    <confirm ref="confirm"></confirm>
    <v-progress-linear v-show="progressBar" slot="progress" color="blue" indeterminate/>

    <v-dialog v-model="Signindialog" persistent width="500">
      <v-card>
        <v-card-title class="grey lighten-2" primary-title
          >Sign in</v-card-title
        >
        <v-card-text>
          <v-form class="px-3">
            <v-text-field
              label="Name"
              v-model="cname"
              prepend-icon="person"
            ></v-text-field>
            <v-text-field
              type="password"
              label="Password"
              v-model="cpassword"
              prepend-icon="lock"
            ></v-text-field>
            <v-btn class="success mx-0 mt-3" @click="submit">Sign in</v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Confirm from "@/components/Confirm";

export default {
  components: { Confirm, },
  data() {
    return { cname: "", cpassword: "", Signindialog: true };
  },
  methods: {
    async submit() {
      this.progressBar = true;
      this.myJsonResp = await this.PostData(
        "Signin",
        JSON.stringify({ name: this.cname, password: this.cpassword })
      );
      this.progressBar = false;
      if (this.myJsonResp != "ERROR") {
        this.data = JSON.parse(this.myJsonResp);
        localStorage.setItem("IIRToken", this.data.TOKEN);
        await this.Loadprofile();
        this.Signindialog = false;
        this.$router.push("/Dashboard");
        this.$router.go(0);
      } else {
        await this.$refs.confirm.open(
          "Access Denied",
          "Invalid User Name or Password",
          "",
          "Close",
          { color: "error" }
        );
      }
    
    },
  },
};
</script>